import { useMemo } from "react";
import { useIntl } from "react-intl";
import Table from "./components/Table";
import { Container } from "./styles";
import { Tooltip } from "antd";
import { useSelector } from "react-redux";

const ContractProductsServices = ({ data = [] }) => {
  const intl = useIntl();
  const { contract } = useSelector((state) => state.initialSettings);

  const columnsProducts = useMemo(
    () => [
      {
        title: intl.formatMessage({ id: "product_name" }),
        dataIndex: "productLocalName",
        key: "productLocalName",
        width: "45%",
      },
      {
        title: intl.formatMessage({ id: "description" }),
        dataIndex: "description",
        key: "description",
        width: "45%",
        render: (text) =>
          text && text.length > 40 ? (
            <Tooltip title={text}>{text.slice(0, 40) + "..."}</Tooltip>
          ) : (
            text || ""
          ),
      },
      {
        title: intl.formatMessage({ id: "quantity" }),
        dataIndex: "quantity",
        key: "quantity",
        width: "10%",
      },
    ],
    [intl]
  );

  const expandedRowRender = (record) => {
    if (!Array.isArray(record.relatedProducts) || record.relatedProducts.length === 0) {
      return null;
    }

    const rowExpandableChild = (record) => Array.isArray(record.relatedProducts) && record.relatedProducts.length > 0;

    const dataWithKey = record.relatedProducts.map((item, idx) => ({
      ...item,
      key: record.key + '_' + idx,
    }));

    return (
      <Table
        dataSource={dataWithKey}
        columns={columnsProducts}
        haveExpandable
        expandedRowRender={expandedRowRender}
        rowExpandable={rowExpandableChild}
        disabledPagination
        isDisabledSeach
        height={200}
      />
    );
  };

  const rowExpandable = (record) => Array.isArray(record.relatedProducts) && record.relatedProducts.length > 0;
  
  const dataWithKey = data.map((item, idx) => ({
    ...item,
    key: contract?.label + '_' + idx,
  }));

  return (
    <Container data-test="CONTRACT_PRODUCTS">
      <Table
        title={intl.formatMessage({ id: "contract_products_and_services" })}
        dataSource={dataWithKey}
        columns={columnsProducts}
        haveExpandable
        expandedRowRender={expandedRowRender}
        rowExpandable={rowExpandable}
        disabledPagination
        isDisabledSeach
      />
    </Container>
  );
};

export default ContractProductsServices;
